module.exports = __webpack_public_path__ + "static/media/build_itinerary.fb95be03.png";